// extracted by mini-css-extract-plugin
export default {"columns":"style_columns__Zj2lw","hiden":"style_hiden__2TfQV"};